import {useEffect, useState} from 'react';
import {useMutation} from 'react-query';
import {
    IGeneratePrimaryTermsResponse,
    IGetPrimaryTermsResponse,
} from '../../models/registration.model';
import {
    generatePrimaryTerms,
    GetPrimaryTerms,
} from '../../services/registration.service';
import AdditionalInfo from '../additionalInfo/additionalInfo';
import DrawerBody from '../requestSteps/drawerBody/drawerBody';
import {IFormInnerState} from '../requestSteps/form/IFormInnerState';
import BasicInformation from './basicInformation';
import LayoutWithoutDrawer from '../../layouts/LayoutWithoutDrawer';
import {useSelector} from 'react-redux';
import {RootState} from '../../redux/store';

export default function BasicInforContainer({
    setStep,
    referenceKey,
    back,
}: IFormInnerState) {
    const [innerState, setInnerState] = useState<
        'additionalInfo' | 'basickInfo'
    >();
    const [content, setContent] = useState<IGetPrimaryTermsResponse>();
    const loanCalculationResult = useSelector(
        (state: RootState) => state.loanCalculationResult
    );

    const {mutate: GetPrimaryTermsMutate, isLoading} = useMutation(
        GetPrimaryTerms,
        {
            onSuccess: (data: IGetPrimaryTermsResponse) => {
                setInnerState!('additionalInfo');
                setContent(data);
            },
        }
    );
    const {mutate: GeneratePrimaryTermsMutate} = useMutation(
        generatePrimaryTerms,
        {
            onSuccess: (data: IGeneratePrimaryTermsResponse) => {
                setInnerState!('additionalInfo');
                setContent(data);
            },
        }
    );

    useEffect(() => {
        if (referenceKey) {
            GetPrimaryTermsMutate({referenceKey: referenceKey!});
        } else {
            GeneratePrimaryTermsMutate({
                financialSupplier: loanCalculationResult.financialSupplier,
                loanAmount: loanCalculationResult.loanAmount,
                loanTemplateId: loanCalculationResult.loanTemplateId,
                organizationId: loanCalculationResult.organizationId,
                stepSpaceId: loanCalculationResult.stepSpaceId,
            });
        }
    }, []);
    const currentState = {
        additionalInfo: (
            <LayoutWithoutDrawer>
                <AdditionalInfo
                    referenceKey={referenceKey!}
                    setInnerState={setInnerState}
                    setStep={setStep}
                    content={content!}
                    primaryTermsServiceLoading={isLoading}
                />
                ,
            </LayoutWithoutDrawer>
        ),
        basickInfo: (
            <DrawerBody>
                <BasicInformation
                    setStep={setStep}
                    referenceKey={referenceKey!}
                    back={back}
                />
            </DrawerBody>
        ),
    };
    return <div>{currentState[innerState!]}</div>;
}
